import gettext from '@sdk/lang/gettext';
import Text14 from '@sdk/components/ui/typography/Text14';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import { ButtonType } from '@sdk/components/ui/buttons/ButtonType';
import ProgressButton from '@sdk/components/ui/buttons/ProgressButton';

import ShiftTaskIcon from '@web/assets/svg/Icons/32/shift-blue.svg';

import { TemplateEditOptionsModal } from './templateEditingOptionsModal.styles';

type Props = {
  onClose: () => void;
  onSubmit: (shouldUpadteTaskInstances: boolean) => Promise<void>;
};

export const TemplateEditingOptionsModal = ({ onClose, onSubmit }: Props) => {
  const firstRowText = gettext('You are modifying a task template.');
  const secondRowText = gettext('Do you want to update future assigned tasks using this template?');
  const title = gettext('Edit task template');

  return (
    <TemplateEditOptionsModal
      buttonsPadding={0}
      fullScreen
      titleText={title}
      titleIcon={<ShiftTaskIcon />}
      buttons={
        <>
          <ProgressButton buttonType={ButtonType.primary} onClick={() => onSubmit(true)}>
            {gettext('Yes, update all future tasks')}
          </ProgressButton>
          <ProgressButton onClick={() => onSubmit(false)}>
            {gettext(`No, don't update them`)}
          </ProgressButton>
        </>
      }
      dismiss={onClose}
      zIndex={1045}>
      <Text14 themeColor={ThemeColorType.gray}>
        {firstRowText} <br /> {secondRowText}
      </Text14>
    </TemplateEditOptionsModal>
  );
};
